import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerFlatNode } from './tree-helper.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tree-selector-modal',
  template: `
    <div>
      <div mat-dialog-title>{{ 'global.selectCustomer' | translate }}</div>
      <div mat-dialog-content style="height:400px; overflow:auto;">
        <customers-tree 
          [isEditMode]="false"
          [isMultipleSelection]="isMultipleSelection"
          [selectedCustomers]="selectedCustomerUid ? [selectedCustomerUid] : []"
          (customerSelectionChange)="this.treeSelectedCustomer = $event.selected">
        </customers-tree>
      </div>
      <div mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>{{ 'global.close' | translate }}</button>
        <button mat-raised-button (click)="confirm()" [disabled]="treeSelectedCustomer.length === 0"
          [class.bg-main-color]="treeSelectedCustomer.length > 0"
          [style.background-color]="treeSelectedCustomer.length === 0 ? 'rgba(0,0,0,.12)' : null">
            {{ 'global.confirm' | translate }}
          </button>
      </div>
    </div>
  `,
  styles: []
})
export class TreeSelectorModalComponent implements OnInit {

  isEditMode: boolean = false;
  isMultipleSelection: boolean = false;
  treeSelectedCustomer: CustomerFlatNode[] = [];
  selectedCustomerUid: string | null = null;
  onConfirm$ = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _translate_Service: TranslateService,
    private dialogRef: MatDialogRef<TreeSelectorModalComponent>
  ) {
    this.selectedCustomerUid = data?.customerUid || null;
    this.isMultipleSelection = data?.isMultipleSelection || false;
    this.isEditMode = this.selectedCustomerUid ? true : false;
  }

  ngOnInit(): void {
    this._translate_Service.use(localStorage.getItem('language') || 'en');
  }

  confirm() {
    // Emit event with selected customer
    if (this.treeSelectedCustomer.length > 0) {
      this.onConfirm$.emit(this.treeSelectedCustomer);
      // Note: dialog will be closed by the subscriber
    }
  }
}